import {useEffect, useRef, useState,} from "react";
import RecordIcon from "./../assets/img/record.svg"
import StopIcon from "./../assets/img/stopRecord.svg"
import getBlobDuration from 'get-blob-duration'

export default function AudioRecorder(props) {
    const [permission, setPermission] = useState(false);
    const [stream, setStream] = useState(null);

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }

    };
    useEffect(() => {
        try {
            getMicrophonePermission()

        } catch (e) {
            console.log(e)
        }
    }, [])

    const mimeType = "audio/mp3";

    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [audioChunks, setAudioChunks] = useState([]);

    const startRecording = async () => {
        if (!permission) {
            await getMicrophonePermission()
            return

        }
        setRecordingStatus("recording");
        //create new Media recorder instance using the stream
        const media = new MediaRecorder(stream, {type: mimeType});
        //set the MediaRecorder instance to the mediaRecorder ref
        mediaRecorder.current = media;
        //invokes the start method to start the recording process
        mediaRecorder.current.start();
        let localAudioChunks = [];
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
    };
    const stopRecording =  () => {
        setRecordingStatus("inactive");
        //stops the recording instance
        mediaRecorder.current.stop();
        mediaRecorder.current.onstop = async () => {
            //creates a blob file from the audiochunks data
            const audioBlob = new Blob(audioChunks, {type: mimeType});

            //creates a playable URL from the blob file.
            const audioUrl = URL.createObjectURL(audioBlob);
            let duration = await getBlobDuration(audioBlob)

            if (props.setAnswer) {
                props.setAnswer({
                    audioBlob,
                    audioUrl,
                    duration: duration
                })
            }

        };
    };

    return (
        <div>
            <main>
                <div className="audio-controls">

                    {recordingStatus === "inactive" ? (
                        <div className={"items-center justify-center text-center"}>
                            <button className={"rounded-full bg-tertiary-100 p-5"} onClick={startRecording}
                                    type="button">
                                <img className={" h-24 w-24"} alt={"recorder"} src={RecordIcon}/>
                            </button>
                            <p>Record</p>

                        </div>
                    ) : null}
                    {recordingStatus === "recording" ? (
                        <div className={"items-center justify-center text-center"}>
                            <button className={"rounded-full bg-red-100 p-5"} onClick={stopRecording}
                                    type="button">
                                <img className={" h-24 w-24 "} src={StopIcon}/>
                            </button>
                            <p>Stop</p>

                        </div>
                    ) : null}
                </div>
            </main>
        </div>
    );
};
